import type { hydrateMyContactDetailForms } from '@/features/Contact/utils/hydrateMyContactDetailForms';

type HydratedRegisterAddressForms = ReturnType<typeof hydrateMyContactDetailForms>;

function sliceFirstRowOnly<T>(list: T[] | null | undefined): T[] {
    if (!Array.isArray(list) || list.length === 0) return [];
    return [list[0]];
}

/** Register 공통 — Beneficial Owner 제외 시 Business 주소 제거 */
export function stripRegisterBusinessAddress(
    hydrated: HydratedRegisterAddressForms,
): HydratedRegisterAddressForms {
    return {
        ...hydrated,
        branchBusinessShowPool: [],
        showBusinessMultiHint: false,
        contactInfoData: {
            ...hydrated.contactInfoData,
            businessAddressList: [],
        },
    };
}

/** Register Officer — Residential·Service·Business 단건 */
export function applyRegisterOfficerAddressConstraints(
    hydrated: HydratedRegisterAddressForms,
): HydratedRegisterAddressForms {
    const branchResidentialList = sliceFirstRowOnly(
        hydrated.branchResidentialList as Record<string, unknown>[],
    );

    const serviceSource = Array.isArray(hydrated.contactInfoData?.serviceAddressList)
        ? (hydrated.contactInfoData.serviceAddressList as Record<string, unknown>[])
        : [];
    const serviceAddressList = sliceFirstRowOnly(serviceSource);

    const businessSource = Array.isArray(hydrated.contactInfoData?.businessAddressList)
        ? (hydrated.contactInfoData.businessAddressList as Record<string, unknown>[])
        : [];
    const businessAddressList = sliceFirstRowOnly(businessSource);

    return {
        ...hydrated,
        branchResidentialList,
        showResidentialMultiHint: false,
        showServiceMultiHint: false,
        showBusinessMultiHint: false,
        contactInfoData: {
            ...hydrated.contactInfoData,
            serviceAddressList,
            businessAddressList,
        },
    };
}

export function sliceOfficerAddressSaveList<T>(list: T[] | null | undefined): T[] | null {
    if (!Array.isArray(list)) return list ?? null;
    if (list.length === 0) return list;
    return [list[0]];
}
